import { c as _c } from "react/compiler-runtime";
import { ApiKey } from '../../../../../../typings/ApiKey.interface';
import { TeamRole } from '../../../../../../typings/TeamMember.interface';
import Button from '../base/Button';
import DropdownMenu from '../DropdownMenu';
interface ApiKeyActionsMenuProps {
  api_key: ApiKey;
  onEditKey?: (api_key: ApiKey) => void;
  onRollKey: (api_key: ApiKey) => void;
  onDeleteKey: (api_key: ApiKey) => void;
  delete_disabled?: boolean;
  delete_tooltip?: string;
  ghost?: boolean;
  // Project role needed to open the menu; below it the button stays visible but disabled.
  // Omit it where the page already restricts access (organization keys).
  required_role?: TeamRole;
  unauthorized_tooltip?: string;
}
export function ApiKeyActionsMenu(t0) {
  const $ = _c(28);
  const {
    api_key,
    onEditKey,
    onRollKey,
    onDeleteKey,
    delete_disabled,
    delete_tooltip,
    ghost: t1,
    required_role,
    unauthorized_tooltip
  } = t0;
  const ghost = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 192
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== ghost || $[2] !== required_role || $[3] !== unauthorized_tooltip) {
    t3 = (opened, toggle) => <Button.Permission role={required_role} unauthorized_tooltip={unauthorized_tooltip} icon="horizontal_more" outline={!ghost} ghost={ghost} active={opened} onClick={() => toggle(!opened)} />;
    $[1] = ghost;
    $[2] = required_role;
    $[3] = unauthorized_tooltip;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== api_key || $[6] !== onEditKey) {
    t4 = onEditKey ? [{
      label: "Edit Key",
      icon: "edit" as const,
      onClick: () => onEditKey(api_key)
    }] : [];
    $[5] = api_key;
    $[6] = onEditKey;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = Boolean(api_key.expires_at);
  let t6;
  if ($[8] !== api_key || $[9] !== onRollKey) {
    t6 = () => onRollKey(api_key);
    $[8] = api_key;
    $[9] = onRollKey;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = {
      label: "Roll Key",
      icon: "roll",
      disabled: t5,
      onClick: t6
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== api_key || $[15] !== onDeleteKey) {
    t8 = () => onDeleteKey(api_key);
    $[14] = api_key;
    $[15] = onDeleteKey;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== delete_disabled || $[18] !== delete_tooltip || $[19] !== t8) {
    t9 = {
      label: "Delete Key",
      icon: "delete",
      danger: true,
      disabled: delete_disabled,
      tooltip: delete_tooltip,
      onClick: t8
    };
    $[17] = delete_disabled;
    $[18] = delete_tooltip;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t4 || $[22] !== t7 || $[23] !== t9) {
    t10 = [...t4, t7, t9];
    $[21] = t4;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3) {
    t11 = <DropdownMenu placement="bottom-end" w={t2} renderToggle={t3} options={t10} />;
    $[25] = t10;
    $[26] = t3;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}